var exports = {
  "D": "ClustersDisablerBox__kbKsG3",
  "R": "ClustersDisablerText__tTtCh7",
};

module.exports = exports;
